// ...existing code...
"use strict";
import { tns } from "tiny-slider";

export default function () {
    const sliders = document.querySelectorAll(".o-feature-product-slider");
    if (!sliders.length) return;

    sliders.forEach((container) => {
        const slider = tns({
            container: container,
            items: 1,
            slideBy: 1,
            controls: false,
            nav: false,
            gutter: 12,
            loop: true,
            touch: true,
            mouseDrag: true,
            responsive: {
                580: {
                    items: 2,
                },
                1024: {
                    items: 3,
                },
            },
        });

        const parent = container.closest(".o-feature-product") || document;
        const arrowLeft = parent.querySelector(".arrows-left");
        const arrowRight = parent.querySelector(".arrows-right");

        if (arrowLeft) {
            arrowLeft.addEventListener("click", () => {
                slider.goTo("prev");
            });
        }
        if (arrowRight) {
            arrowRight.addEventListener("click", () => {
                slider.goTo("next");
            });
        }
    });
}
